// Written in this round about way for babel-transform-imports
import Redirect from 'react-router/es/Redirect';

export default Redirect;


//////////////////
// WEBPACK FOOTER
// c:/jenkins/workspace/plesk-17.8/~/react-router-dom/es/Redirect.js
// module id = 47
// module chunks = 1 2 3 4 5